import React from 'react';
import { useTranslation } from 'react-i18next';
import { Day } from '../../../domain/level';
import imageClock from '../../../assets/images/clock.png';
import { createUseStyles } from 'react-jss';

export interface ITimerProps {
    time: number;
    day: Day;
}

const useStyles = createUseStyles({
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    image: {
        position: 'absolute',
        top: '0px',
        left: 0,
        width: '300px',
    },
    text: {
        position: 'absolute',
        top: '80px',
        left: '120px',
    },
});

export const Timer: React.FunctionComponent<ITimerProps> = props => {
    const styles = useStyles();
    const { t } = useTranslation();

    return (
        <div className={styles.root}>
            <img className={styles.image} src={imageClock} alt="clock" />
            <div className={styles.text}>
                <div>{t(`timer.weekdays.${props.day.name}`)}</div>
                <div>{t(`timer.time.${props.time}`)}</div>
            </div>
        </div>
    );
};
